<template>
<div id="Clinics">
<Clinics :AllowEdit="true"/>
</div>
</template>

<script> 
import Vue from 'vue'; 
import Clinics from '@/components/DPEBB/Administrator/Clinics.vue'
import LayoutDefault from '@/Common/Default/DefaultLayout.vue';
export default {
    data: function (){
        return {
        AppServiceID :6,
        }
    },
    components: {
        Clinics
    },
created: function() {
    this.$emit('update:layout', LayoutDefault);
},    
beforeCreate: function() {
        this.$store.dispatch('AddServiceID',this.$store.getters.GetDPEBBServiceID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetDPEBBServiceID);
    },
}
</script>

<style>

</style>
